import { menuTypeDict } from '@/dictionary/menu'
import { companyTypeDict } from '@/dictionary/company'
import {
  platformFunctionModuleDict,
  workbenchServiceDict
} from '@/dictionary/system'

/**
 * 投标报价 - 已参与项目 - 招标采购
 */
export default {
  path: 'bid',
  type: menuTypeDict.DIRECTORY.value,
  meta: {
    title: '招标采购',
    layout: 'DefaultLayout'
  },
  applicableCompanyTypes: [
    { companyType: companyTypeDict.ENTERPRISE.value },
    { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
    { companyType: companyTypeDict.SELF_EMPLOYEE.value },
    { companyType: companyTypeDict.PERSON.value }
  ],
  platformAlias: [],
  applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
  roles: [
    platformFunctionModuleDict.SUPPLIER.right,
    platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
  ],
  superviseInstitutions: [],

  children: [
    // 项目列表
    {
      path: 'list',
      name: 'ParticipateBid',
      component: '/supplier-views/participate/bid',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '项目列表',
        cache: true,
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value },
        { companyType: companyTypeDict.PERSON.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 项目详情
    {
      path: 'orders/:orderId/info',
      name: 'SupplierPurchaseDetail',
      component: '/supplier-views/purchase/index',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '项目详情',
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value },
        { companyType: companyTypeDict.PERSON.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 报名详情
    {
      path: 'orders/:orderId/trades/:tradeId?',
      name: 'SupplierPurchaseSignUp',
      component: '/supplier-views/purchase/apply',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '报名详情',
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value },
        { companyType: companyTypeDict.PERSON.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 变更公告
    {
      path: 'orders/:orderId/signups/change-detail',
      name: 'SupplierPurchaseChangeDetail',
      component: '/supplier-views/purchase/change-detail',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '变更公告',
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value },
        { companyType: companyTypeDict.PERSON.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 电子化全流程
    {
      path: 'kpbProject',
      type: menuTypeDict.DIRECTORY.value,
      meta: {
        title: '电子化全流程',
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value },
        { companyType: companyTypeDict.PERSON.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: [],

      children: [
        // 开标大厅
        {
          path: ':projectId/hall/bidder/:bidderId',
          type: menuTypeDict.DIRECTORY.value,
          meta: {
            title: '开标大厅',
            hidden: true,
            layout: 'BidOpenHallLayout'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
            { companyType: companyTypeDict.SELF_EMPLOYEE.value },
            { companyType: companyTypeDict.PERSON.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
          roles: [
            platformFunctionModuleDict.SUPPLIER.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: [],

          children: [
            // 倒计时
            {
              path: 'door',
              name: 'SupplierBidOpenHallDoor',
              component: '/hall/bid-open-hall/bid-open-hall-door',
              type: menuTypeDict.MENU.value,
              meta: {
                title: '倒计时',
                hidden: true
              },
              applicableCompanyTypes: [
                { companyType: companyTypeDict.ENTERPRISE.value },
                {
                  companyType: companyTypeDict.PUBLIC_INSTITUTION.value
                },
                { companyType: companyTypeDict.SELF_EMPLOYEE.value },
                { companyType: companyTypeDict.PERSON.value }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
              roles: [
                platformFunctionModuleDict.SUPPLIER.right,
                platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
              ],
              superviseInstitutions: []
            },

            // 文件解密
            {
              path: 'home',
              name: 'SupplierBidOpenHallHome',
              component: '/hall/bid-open-hall/bid-open-hall-supplier',
              type: menuTypeDict.MENU.value,
              meta: {
                title: '文件解密',
                hidden: true
              },
              applicableCompanyTypes: [
                { companyType: companyTypeDict.ENTERPRISE.value },
                {
                  companyType: companyTypeDict.PUBLIC_INSTITUTION.value
                },
                { companyType: companyTypeDict.SELF_EMPLOYEE.value },
                { companyType: companyTypeDict.PERSON.value }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
              roles: [
                platformFunctionModuleDict.SUPPLIER.right,
                platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
              ],
              superviseInstitutions: []
            }
          ]
        },

        // 评审大厅
        {
          path: ':projectId/review-hall/bidder/:bidderId',
          type: menuTypeDict.DIRECTORY.value,
          meta: {
            title: '评审大厅',
            hidden: true,
            layout: 'ReviewHallLayout'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
            { companyType: companyTypeDict.SELF_EMPLOYEE.value },
            { companyType: companyTypeDict.PERSON.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
          roles: [
            platformFunctionModuleDict.SUPPLIER.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: [],

          children: [
            // 评审大厅
            {
              path: 'home',
              name: 'SupplierBidReviewHallHome',
              component: '/hall/review-hall/supplier-view',
              type: menuTypeDict.MENU.value,
              meta: {
                title: '评审大厅',
                hidden: true
              },
              applicableCompanyTypes: [
                { companyType: companyTypeDict.ENTERPRISE.value },
                {
                  companyType: companyTypeDict.PUBLIC_INSTITUTION.value
                },
                { companyType: companyTypeDict.SELF_EMPLOYEE.value },
                { companyType: companyTypeDict.PERSON.value }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
              roles: [
                platformFunctionModuleDict.SUPPLIER.right,
                platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
              ],
              superviseInstitutions: []
            }
          ]
        }
      ]
    },

    // 招标文件详情
    {
      path: 'orders/:orderId/file-info/:kpbProjectId',
      name: 'SupplierInviteBidFileInfo',
      component:
        '/procure-views/purchase/invite-bid/invite-bid-detail/bid-file-detail',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '招标文件详情',
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value },
        { companyType: companyTypeDict.PERSON.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 招标文件详情（澄清）
    {
      path:
        'order/:orderId/trade/:tradeId/kpb-project/supplement/:supplementId/bidding-file/:biddingFileId',
      name: 'SupplierKpbBidFileDetail',
      component:
        '/procure-views/purchase/invite-bid/invite-bid-detail/bid-file-detail',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '招标文件详情',
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value },
        { companyType: companyTypeDict.PERSON.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 异议处理
    {
      path: 'objection/list',
      name: 'SupplierObjectionList',
      component: '/supplier-views/purchase/objection/index',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '异议处理',
        hidden: true,
        cache: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value },
        { companyType: companyTypeDict.PERSON.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 新增异议
    {
      path: 'objection/create',
      name: 'SupplierObjectionCreate',
      component: '/supplier-views/purchase/objection/create',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '新增异议',
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value },
        { companyType: companyTypeDict.PERSON.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    }
  ]
}
